import script from "./SvgContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgContainer.vue?vue&type=script&setup=true&lang=ts"

import "./SvgContainer.vue?vue&type=style&index=0&id=4ed77cfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ed77cfe"]])

export default __exports__